import { render, staticRenderFns } from "./all-products.vue?vue&type=template&id=dbcfe0b4&"
import script from "./all-products.vue?vue&type=script&lang=js&"
export * from "./all-products.vue?vue&type=script&lang=js&"
import style0 from "./all-products.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports